/* Liberation of Flowers — product-box gallery.
   Prev/next arrow nav over a scroll-snap track (mobile swipe is native CSS).
   One controller per section instance; no dependencies. */
(function () {
  function initGallery(root) {
    if (root.dataset.lofGalleryReady) return;
    root.dataset.lofGalleryReady = '1';

    var track = root.querySelector('[data-lof-track]');
    var prev = root.querySelector('[data-dir="prev"]');
    var next = root.querySelector('[data-dir="next"]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function go(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-lof-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init in the theme editor when the section is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
